module.exports = __webpack_public_path__ + "static/media/login_bg.0f7e8445.png";